import React, { Component } from 'react';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import AppFrameLayout from '../global/app_frame/app_frame_layout';
import PcoSongsLayout from './pco_songs/pco_songs_layout';

import appFrameReducer from '../global/app_frame/app_frame_reducer';
import pcoSongsReducer from './pco_songs/pco_songs_reducer';
import usersReducer from '../global/user/user_reducer';
import organizationReducer from '../global/organization/organization_reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    app_frame: appFrameReducer,
    pco_songs: pcoSongsReducer,
    user: usersReducer,
    organization: organizationReducer,
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

class PcoSongsApp extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <AppFrameLayout>
                        <PcoSongsLayout />
                    </AppFrameLayout>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default PcoSongsApp;
